import { floor } from 'lodash'
import { quizScoreDisplay } from '@/app/quiz/components/quiz-score-display'

export const EXAM_SCORE_DISPLAY_PRECISION = 1
const EXAM_PERCENT_DISPLAY_PRECISION = 1

export function examScoreDisplay(score: number) {
  return quizScoreDisplay(score, EXAM_SCORE_DISPLAY_PRECISION)
}

export function examPercentDisplay(percent: number) {
  return floor(percent, EXAM_PERCENT_DISPLAY_PRECISION)
}
